/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "checkmate": {
            "nested": {
              "service": {
                "nested": {
                  "CheckDeposit": {
                    "fields": {
                      "customerToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "originalCheckFrontTrunkToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "originalCheckBackTrunkToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "processedCheckFrontTrunkToken": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "processedCheckBackTrunkToken": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "mitekTransactionReferenceToken": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "amountCents": {
                        "type": "int64",
                        "id": 7,
                        "rule": "optional"
                      },
                      "state": {
                        "type": "squareup.cash.checkmate.service.CheckState",
                        "id": 8,
                        "rule": "optional"
                      },
                      "micrFideliusToken": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      },
                      "stateReason": {
                        "type": "squareup.cash.checkmate.service.StateReason",
                        "id": 10,
                        "rule": "optional"
                      },
                      "token": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      },
                      "referenceToken": {
                        "type": "string",
                        "id": 12,
                        "rule": "optional"
                      },
                      "depositOrigin": {
                        "type": "squareup.cash.checkmate.service.DepositOrigin",
                        "id": 13,
                        "rule": "optional"
                      },
                      "fundsReleasedAtMillis": {
                        "type": "int64",
                        "id": 14,
                        "rule": "optional"
                      },
                      "ingestionErrors": {
                        "type": "squareup.cash.checkmate.service.IngestionError",
                        "id": 15,
                        "rule": "repeated"
                      },
                      "checkReturn": {
                        "type": "squareup.cash.checkmate.service.CheckReturn",
                        "id": 16,
                        "rule": "optional"
                      },
                      "accountAndRoutingFideliusToken": {
                        "type": "string",
                        "id": 17,
                        "rule": "optional"
                      },
                      "idempotenceToken": {
                        "type": "string",
                        "id": 18,
                        "rule": "optional"
                      },
                      "finplatCheckDepositToken": {
                        "type": "string",
                        "id": 19,
                        "rule": "optional"
                      }
                    }
                  },
                  "DepositOrigin": {
                    "values": {
                      "ORIGIN_UNKNOWN_DO_NOT_USE": 0,
                      "CASH_APP": 1,
                      "SQUARE_BANKING": 2
                    }
                  },
                  "CheckState": {
                    "values": {
                      "INITIATED": 1,
                      "REVIEWING": 2,
                      "PROCESSING": 3,
                      "FAILED": 4,
                      "COMPLETED": 5,
                      "RETURNED": 6,
                      "INGESTING": 7,
                      "FUNDS_HOLD": 8,
                      "WAITING_REVIEW": 9
                    }
                  },
                  "StateReason": {
                    "values": {
                      "INGEST_SUCCEEDED": 1,
                      "INGEST_UNEXPECTED_ERROR": 2,
                      "INGEST_POOR_IMAGE_QUALITY": 3,
                      "REVIEW_APPROVED": 4,
                      "REVIEW_NAME_MISMATCH": 5,
                      "REVIEW_AUTO": 6,
                      "FUNDS_AVAILABLE": 7,
                      "RETURNED_CHECK_BOUNCED": 8,
                      "REVIEW_CHECK_TYPE": 9,
                      "REVIEW_ENDORSEMENT": 10,
                      "REVIEW_AMOUNT_MISMATCH": 11,
                      "REVIEW_DATE_INVALID": 12,
                      "REVIEW_OTHER": 13,
                      "ADJUSTED_CHECK_AMOUNT": 14,
                      "INGEST_DUPLICATE": 15,
                      "FUNDS_HOLD_RELEASED": 16,
                      "INITIATE_SUCCEEDED": 17,
                      "REVIEW_APPROVED_WITH_FUNDS_HOLD": 18,
                      "FUNDS_ON_HOLD": 19,
                      "SETTLED_BY_WELLS": 20,
                      "INGEST_TIMEOUT": 21,
                      "PROCESSING_TIMEOUT": 22,
                      "SETTLED_OUT_OF_BAND": 23,
                      "INGEST_CHECK_TYPE": 24,
                      "INGEST_DATE_INVALID": 25,
                      "INGEST_AMOUNT_MISMTACH": 26,
                      "INGEST_FRONT_SCANNED_AS_BACK": 27,
                      "REVIEW_ENDORSEMENT_FIXABLE": 28,
                      "REVIEW_ENDORSEMENT_UNFIXABLE": 29,
                      "REVIEW_REFER_TO_MAKER": 30,
                      "REVIEW_ALTERED_OR_FICITIOUS": 31,
                      "REVIEW_POOR_IMAGE_QUALITY": 32,
                      "REVIEW_STALE_DATED": 33,
                      "REVIEW_POST_DATED": 34,
                      "REVIEW_ENDORSEMENT_MISSING": 35,
                      "REVIEW_ENDORSEMENT_IRREGULAR": 36,
                      "REVIEW_SIGNATURE_MISSING": 37,
                      "REVIEW_SIGNATURE_IRREGULAR": 38,
                      "REVIEW_NON_CASH_ITEM": 39,
                      "REVIEW_UNABLE_TO_PROCESS": 40,
                      "REVIEW_ITEM_EXCEEDS_DOLLAR_LIMIT": 41,
                      "REVIEW_NOT_AUTHORIZED": 42,
                      "REVIEW_BRANCH_ACCOUNT_SOLD": 43,
                      "REVIEW_STOP_PAYMENT_SUSPECT": 44,
                      "REVIEW_IMAGE_FAILS_SECURITY_CHECK": 45,
                      "REVIEW_CANNOT_DETERMINE_AMOUNT": 46,
                      "REVIEW_IRD_USER_DEFINED": 47,
                      "REVIEW_MY_DEPOSIT_PROHIBITED_ITEM": 48,
                      "REVIEW_ENDORSEMENT_DOES_NOT_MEET_REQUIREMENTS": 49,
                      "REVIEW_MISSING_FOR_MOBILE_DEPOSIT_ONLY_WITH_ENDORSEMENT": 50,
                      "INITIATE_STUCK": 51,
                      "REVIEW_CUSTOMER_RISK_SCORE": 52,
                      "MISTAKENLY_RETURNED": 53,
                      "MISTAKENLY_ACCEPTED": 54
                    }
                  },
                  "CheckReturn": {
                    "fields": {
                      "returnReason": {
                        "type": "squareup.cash.checkmate.service.CheckReturn.ReturnReason",
                        "id": 1,
                        "rule": "optional"
                      },
                      "returnCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "returnReasonDescription": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ReturnReason": {
                        "values": {
                          "NSF": 1,
                          "UCF": 2,
                          "STOP_PAYMENT": 3,
                          "CLOSED_ACCOUNT": 4,
                          "UTLA": 5,
                          "FROZEN_ACCOUNT": 6,
                          "STALE_DATED": 7,
                          "POST_DATED": 8,
                          "ENDORSEMENT_MISSING": 9,
                          "ENDORSEMENT_IRREGULAR": 10,
                          "SIGNATURE_MISSING": 11,
                          "SIGNATURE_IRREGULAR": 12,
                          "NON_CASH_ITEM": 13,
                          "ALTERED_FICTITIOUS": 14,
                          "UNABLE_TO_PROCESS": 15,
                          "EXCEEDS_STATED_MAX_VALUE": 16,
                          "NOT_AUTHORIZED": 17,
                          "BRANCH_ACCOUNT_SOLD": 18,
                          "REFER_TO_MAKER": 19,
                          "CANNOT_RE_PRESENT": 20,
                          "UNUSABLE_IMAGE": 21,
                          "INVALID_IMAGE": 22,
                          "CANNOT_DETERMINE_AMOUNT": 23,
                          "REFER_TO_IMAGE": 24,
                          "DUPLICATE_PRESENTMENT": 25,
                          "ACH_ADMIN_RETURN": 26,
                          "FORGERY": 27,
                          "WARRANTY_BREACH": 28,
                          "RCC_WARRANTY_BREACH": 29,
                          "FORGED_AND_COUNTERFEIT_WARRANTY_BREACH": 30,
                          "RETIRED_INELIGIBLE_ROUTUNG_NUMBER": 31,
                          "UNKNOWN": 32
                        }
                      }
                    }
                  },
                  "IngestionError": {
                    "fields": {
                      "errorCode": {
                        "type": "uint64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errorMessage": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.checkmate?.nested?.service?.nested?.CheckDeposit && !$root.nested?.squareup?.nested?.cash?.nested?.checkmate?.nested?.service?.nested?.DepositOrigin && !$root.nested?.squareup?.nested?.cash?.nested?.checkmate?.nested?.service?.nested?.CheckState && !$root.nested?.squareup?.nested?.cash?.nested?.checkmate?.nested?.service?.nested?.StateReason && !$root.nested?.squareup?.nested?.cash?.nested?.checkmate?.nested?.service?.nested?.CheckReturn && !$root.nested?.squareup?.nested?.cash?.nested?.checkmate?.nested?.service?.nested?.CheckReturn?.nested?.ReturnReason && !$root.nested?.squareup?.nested?.cash?.nested?.checkmate?.nested?.service?.nested?.IngestionError) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CheckDeposit @ squareup/cash/checkmate/api/CheckDepositProto.proto at 6:1
 */
export const CheckDeposit = $root.lookupType('squareup.cash.checkmate.service.CheckDeposit');
fixType(CheckDeposit);
Builder.createAndAttachToType(CheckDeposit);
/**
 * The origin allows downstream consumers of the MobileCheckDeposit topic to
 * selectively process the balance modification event.
 *
 * SOURCE DepositOrigin @ squareup/cash/checkmate/api/CheckDepositProto.proto at 39:1
 */
export const DepositOrigin = $root.lookupEnum('squareup.cash.checkmate.service.DepositOrigin').values;
/**
 * SOURCE CheckState @ squareup/cash/checkmate/api/CheckDepositProto.proto at 49:1
 */
export const CheckState = $root.lookupEnum('squareup.cash.checkmate.service.CheckState').values;
/**
 * SOURCE StateReason @ squareup/cash/checkmate/api/CheckDepositProto.proto at 61:1
 */
export const StateReason = $root.lookupEnum('squareup.cash.checkmate.service.StateReason').values;
/**
 * SOURCE CheckReturn @ squareup/cash/checkmate/api/CheckDepositProto.proto at 118:1
 */
export const CheckReturn = $root.lookupType('squareup.cash.checkmate.service.CheckReturn');
fixType(CheckReturn);
Builder.createAndAttachToType(CheckReturn);
/**
 * SOURCE ReturnReason @ squareup/cash/checkmate/api/CheckDepositProto.proto at 119:3
 */
CheckReturn.ReturnReason = $root.lookupEnum('squareup.cash.checkmate.service.CheckReturn.ReturnReason').values;
/**
 * SOURCE IngestionError @ squareup/cash/checkmate/api/CheckDepositProto.proto at 159:1
 */
export const IngestionError = $root.lookupType('squareup.cash.checkmate.service.IngestionError');
fixType(IngestionError);
Builder.createAndAttachToType(IngestionError);